import { Product } from './product';

export class SpotlightProduct extends Product {}
